@if (kind === 'patents') {
  @if (patents.length) {
    <ol class="tax-history__list" aria-label="Patent filings, newest first">
      @for (patent of patents; track $index) {
        <li class="tax-history__item">
          <div class="tax-history__head">
            <h3>{{ patent.title || 'Untitled patent record' }}</h3>
            @if (patent.status) {<span class="tax-history__chip" [class.tax-history__chip--positive]="patent.statusTone === 'positive'" [class.tax-history__chip--muted]="patent.statusTone === 'muted'">{{ patent.status }}</span>}
          </div>
          <dl class="tax-history__facts">
            <div><dt>Filed</dt><dd [class.tax-history__blank]="!patent.filed">{{ patent.filed ? (patent.filed | date:'d MMM y') : '–' }}</dd></div>
            @if (patent.lodged) {<div><dt>Lodged</dt><dd>{{ patent.lodged | date:'d MMM y' }}</dd></div>}
            @if (patent.applicationNumber) {<div><dt>Application no.</dt><dd>{{ patent.applicationNumber }}</dd></div>}
            @if (patent.publicationNumber) {<div><dt>Publication no.</dt><dd>{{ patent.publicationNumber }}</dd></div>}
            @if (patent.revoked) {<div><dt>Revoked</dt><dd>{{ patent.revoked | date:'d MMM y' }}</dd></div>}
            @if (patent.expired) {<div><dt>Expired</dt><dd>{{ patent.expired | date:'d MMM y' }}</dd></div>}
          </dl>
          @if (patent.url) {<a class="tax-history__link" [href]="patent.url" target="_blank" rel="noopener noreferrer">View on the IPO register <i class="fal fa-arrow-up-right" aria-hidden="true"></i><span class="tax-history__sr-only"> (opens in a new tab)</span></a>}
        </li>
      }
    </ol>
  } @else {
    <p class="tax-history__empty">No patent filings are recorded for this company.</p>
  }
} @else if (kind === 'grants') {
  @if (grants.length) {
    <ol class="tax-history__list" aria-label="Grant projects, newest first">
      @for (grant of grants; track $index) {
        <li class="tax-history__item">
          <div class="tax-history__head">
            <h3>{{ grant.title || 'Untitled grant project' }}</h3>
            @if (grant.timing) {<span class="tax-history__chip" [class.tax-history__chip--positive]="grant.timing === 'In progress'" [class.tax-history__chip--muted]="grant.timing === 'Ended'">{{ grant.timing }}</span>}
          </div>
          <dl class="tax-history__facts">
            <div class="tax-history__fact--lead"><dt>Grant offered</dt><dd [class.tax-history__blank]="grant.offered === null">{{ grant.offered === null ? '–' : (grant.offered | currency:'GBP':'symbol':'1.0-0') }}</dd></div>
            <div><dt>Total project costs</dt><dd [class.tax-history__blank]="grant.totalCosts === null">{{ grant.totalCosts === null ? '–' : (grant.totalCosts | currency:'GBP':'symbol':'1.0-0') }}</dd></div>
            @if (grant.spendToDate !== null) {<div><dt>Spend to date</dt><dd>{{ grant.spendToDate | currency:'GBP':'symbol':'1.0-0' }}</dd></div>}
            <div>
              <dt>Project dates</dt>
              <dd [class.tax-history__blank]="!grant.start && !grant.end">
                @if (grant.start && grant.end) {
                  {{ grant.start | date:'d MMM y' }} to {{ grant.end | date:'d MMM y' }}
                } @else if (grant.start) {
                  From {{ grant.start | date:'d MMM y' }}
                } @else if (grant.end) {
                  Until {{ grant.end | date:'d MMM y' }}
                } @else {
                  –
                }
              </dd>
            </div>
          </dl>
          @if (grant.summary) {
            <details class="tax-history__summary">
              <summary>Project summary <i class="fal fa-chevron-down" aria-hidden="true"></i></summary>
              <p>{{ grant.summary }}</p>
            </details>
          }
        </li>
      }
    </ol>
  } @else {
    <p class="tax-history__empty">No grant projects are recorded for this company.</p>
  }
} @else {
  @if (energy.length) {
    <div class="tax-history__tabs" role="tablist" aria-label="Energy and emissions section">
      @for (tab of energy; track tab.id) {
        <button type="button" role="tab" [id]="'tax-history-tab-' + tab.id" [attr.aria-selected]="activeEnergyTab === tab.id" [attr.aria-controls]="'tax-history-panel-' + tab.id" [class.active]="activeEnergyTab === tab.id" (click)="selectTab(tab.id)">{{ tab.label }}</button>
      }
    </div>
  }
  @if (activeTab; as tab) {
    <div class="tax-history__panel" role="tabpanel" [id]="'tax-history-panel-' + tab.id" [attr.aria-labelledby]="'tax-history-tab-' + tab.id">
      @if (tab.rows.length) {
        <company-profile-period-table
          [columns]="tab.columns"
          [rows]="tab.rows"
          [caption]="tab.label + ', one column per reporting period, newest first'"
          [regionLabel]="tab.label + ' figures by period. Scroll sideways for earlier periods.'"
          [summaryLead]="periodsText(tab.columns.length)"
          [summaryDetail]="tab.unitNote"
          [(showChange)]="showChange">
        </company-profile-period-table>
      } @else {
        <p class="tax-history__empty">No {{ tab.label.toLowerCase() }} figures are recorded for this company.</p>
      }
    </div>
  }
}
